import { AccountHelper } from "../helpers/account";
import HttpClient, { http } from "../helpers/client";
import { IResponse } from "../interfaces/response.interface";

export type ISiteSettings = {
    hide_on_decentralize?: ISetting
}

export type ISiteSettingsResponse = {
    success: boolean,
    data: ISetting[]
}

export type ISetting = {
    ID?: string,
    set_name?: string | null,
    type?: string,
    value?: any,
    uid?: string,
    hasOwner?: boolean
}

interface ISettingsSystemSettings {
    hide_on_decentralize?: number | string | null,
    ui_compact?: number | string | null,
    ticker_active?: number | string | null,
    cattletrace?: number | string | null
    hide_declined?: number | string | null,
    hide_sold?: number | string | null,
    hide_archived?: number | string | null
}

interface ISystemSettingsSubscription {
    expired: boolean,
    exists: boolean,
    created_at?: string,
    expires_at?: string,
    application_status?: number
}

interface ISystemSettingsWizardStartUp {
    exists: boolean
}

interface ISystemSettingsGlobal {
    listing_payments: string | number,
    ignore_merchant_hold: string | number,
    ignore_trans_exp: string | number,
    ignore_funds_check: string | number,
    force_sweep: string | number,
    force_cron: string | number,
    flush_app_user: string | number,
    user_login: string | number,
    flush_user_admin: string | number,
    skip_user_verification: string | number,
    user_signup: string | number,
    soft_delete: string | number,
    marketplace: string | number,
    account_upgrade: string | number,
    cattletrace: string | number,
    paymentTypes: ('crypto' | 'fiat')[]
}

interface ISystemSettingsDashboard {
    image: string
}

interface ISystemSettingsDocs {
    ID: string,
    fname: string,
    ref_id: string | null,
    title: string,
    description: string,
    status: string,
    role: string,
    type: string,
    subaccount: string | null,
    sort_order: number,
    uploaded_by: number,
    created_at: string,
    updated_at: string,
    deleted_at: string | null
}
export interface ISettingsUser {
    system: ISettingsSystemSettings,
    communique: Record<string, number | string | null>[],
    subscription: ISystemSettingsSubscription,
    plugins: unknown[],
    wizard_startup: ISystemSettingsWizardStartUp,
    global: ISystemSettingsGlobal,
    dashboard: ISystemSettingsDashboard,
    docs: ISystemSettingsDocs[]
}

export async function SiteSettings() //Promise<ISiteSettingsResponse>
{
    const data = await GeneralAccountSettingsGetService(AccountHelper().id?.toString() || '')
    return data.data?.system || {}
    //return SettingsGetGroup<ISiteSettingsResponse>('site')
}

export function SettingsGetGroup<T>(key: string): Promise<T>
{
    return (new HttpClient()).get<T>(`setting/group/${key}`)
}

export function SettingsGetAttr(key: string): Promise<ISetting>
{
    return (new HttpClient()).get<ISetting>(`setting/attr/${key}`)
}

export function SettingsSetAttr(body: any): Promise<any>//Promise<ISetting>
{
    return GeneralAccountSettingsSaveService(body)
    // return (new HttpClient()).post<ISetting>(`setting/attr/${key}`, body)
}

export const SettingsRemoveAttr = (key: string) => {
    return (new HttpClient()).delete<{ success: boolean }>(`setting/attr/${key}`)
}

export const GeneralAccountSettingsGetService = (uid: string): Promise<IResponse<ISettingsUser>> => {
    return http().get<IResponse<ISettingsUser>>(`internal/settings/${uid}/`)
}

export const GeneralAccountSettingsSaveService = (settings: any): Promise<IResponse<any>> => {
    return http().post<IResponse<any>>('internal/settings/', settings)
}

export const SystemGetService = <T = any>(type?: string) => http().get<IResponse<T>>(`global-settings${type? `/${type}/`: ''}`)